import { ensureLatAndLng } from "../modules/project";
import { createSelector } from "reselect";
const initialState = {
    geojson: null,
    projectsByFundName: {},
};
export default (state = initialState, action) => {
    switch (action.type) {
        case "PROJECT:ALL:REQUEST":
            return state;
        case "GEOJSON:REQUEST": {
            return { ...state, geojson: null };
        }
        case "GEOJSON:SUCCESS":
            return { ...state, geojson: action.payload };
        case "GEOJSON:FAILURE":
        case "PROJECT:ALL:FAILURE":
            console.error(action.payload);
            return { ...state, error: action.payload };
        case "PROJECT:ALL:SUCCESS":
            const projectsByFundName = action.payload.reduce(
                (acc, { fundName, data }) => {
                    acc[fundName] = data.filter(ensureLatAndLng);
                    return acc;
                },
                {}
            );

            return {
                ...state,
                projectsByFundName,
            };
        default:
            return state;
    }
};

const addFundName = fundName => project => ({ ...project, fundName });

// Selects all data from projectsByFundName in one array.
// It also adds the fundName each item
const selectAllProjects = createSelector(
    state => state.projectsByFundName,
    projectsByFundName => {
        return Object.entries(projectsByFundName)
            .map(([fundName, data]) => data.map(addFundName(fundName)))
            .reduce((acc, val) => acc.concat(val), []);
    }
);
export const selectGeoJSON = state => state.geojson;

export const selectFilteredProjects = createSelector(
    fundNames => fundNames,
    (fundNames, viewingFund) => viewingFund,
    (fundNames, viewingFund, state) => selectAllProjects(state),
    (fundNames, viewingFund, allProjects) => {
        if (viewingFund) {
            return allProjects.filter(d => d.fundName === viewingFund);
        } else if (fundNames && fundNames.length > 0) {
            return allProjects.filter(d => !fundNames.includes(d.fundName));
        } else {
            return allProjects;
        }
    }
);

export const selectAllFunds = createSelector(
    s => s.projectsByFundName,
    projectsByFundName => Object.keys(projectsByFundName)
);



// WEBPACK FOOTER //
// ./src/reducers/data.js